import { SalesOrderContractTaskComment } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1782. 受注案件契約タスクコメント編集
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_contract_tasks/:sales_order_contract_task_id/sales_order_contract_task_comments/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  id: number;
  content: string;
  content_json: string;
};

const updateSalesOrderContractTaskComment = (props: Props): Promise<SalesOrderContractTaskComment> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_contract_tasks/${props.task_id}/sales_order_contract_task_comments/${props.id}`,
    props
  );
};

export const useUpdateSalesOrderContractTaskComment = () => {
  return useMutation({
    mutationFn: updateSalesOrderContractTaskComment,
  });
};
